import {optionIndex, optionsOf, findVariant, normalizePhone} from './wearse-landing-core.js';
import {submitEasySell, hasPendingOrder} from './wearse-classic-easysell.js?v=20260912-sheets-v1';

const sheetPendingKey='wearse-chaussures-sheet-pending';

class WearseClassic extends HTMLElement {
  connectedCallback() {
    if(this.initialized)return;
    this.initialized=true;
    this.config=JSON.parse(this.querySelector('[data-classic-config]').textContent);
    this.form=this.querySelector('.wc-form');
    this.error=this.querySelector('.wc-error');
    this.submitButton=this.querySelector('.wc-submit');
    this.buttonHTML=this.submitButton.innerHTML;
    this.quantity=Number(this.form.elements.offer.value)||2;
    this.product=this.config.product;
    this.selections=[];
    this.abort=new AbortController();
    const signal=this.abort.signal;
    this.form.addEventListener('submit',e=>this.submit(e),{signal});
    this.form.addEventListener('input',e=>{e.target.removeAttribute('aria-invalid');},{signal});
    this.form.addEventListener('change',e=>{if(e.target.name==='offer'){this.quantity=Number(e.target.value);this.renderVariants();this.updateTotal();this.error.hidden=true;}},{signal});
    this.querySelectorAll('[data-color]').forEach(button=>button.addEventListener('click',()=>{
      if(this.colors){const color=this.colors.find(c=>c.toLowerCase()===button.dataset.color.toLowerCase());if(color){this.selections[0]={color,size:this.selections[0]?.size||''};this.renderVariants();this.updateHero(color);}}
    },{signal}));
    this.setupVideo(signal);
    this.catalogReady=this.loadCatalog();
    this.submitButton.disabled=!this.catalogReady||(!this.config.enabled&&!this.config.preview)||hasPendingOrder();
    this.querySelector('[data-order-unavailable]').hidden=Boolean(this.catalogReady&&(this.config.enabled||this.config.preview));
    if(hasPendingOrder()){
      this.submitButton.textContent='Confirmation à vérifier';
      this.showError('Une commande attend confirmation. Contactez-nous sur WhatsApp avant de la renvoyer.');
    }
    if(!this.catalogReady){this.renderVariants();if(!this.selectionOnly)this.showError('Ce modèle est momentanément indisponible à la commande.');}
    this.updateTotal();
    this.retryPendingSheetSync();
  }
  disconnectedCallback(){this.abort?.abort();this.initialized=false;}
  updateHero(color){
    const image=this.querySelector('#hero-shoe');
    const asset=this.querySelector(color.toLowerCase()==='marron'?'.brown-panel .panel-product img':'.black-panel .panel-product img');
    if(image&&asset){image.src=asset.src;image.alt='Mocassin WEARSE classique en cuir '+color.toLowerCase();}
    const caption=this.querySelector('#hero-caption');if(caption)caption.textContent='Le classique · '+color;
    this.querySelectorAll('[data-color]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.color===color)));
  }
  loadCatalog(){
    this.selectionOnly=!this.product?.id;
    this.colors=null;
    if(this.selectionOnly){
      this.colors=['Noir','Marron'];
      this.sizes=[...new Set((this.config.confirmedSizes||[]).map(s=>String(s).trim()).filter(s=>/^\d+$/.test(s)))];
      this.renderVariants();return false;
    }
    if(!this.product?.id||!Array.isArray(this.product.variants)||!Array.isArray(this.product.options))return false;
    this.ci=optionIndex(this.product,this.config.colorOption);
    this.si=optionIndex(this.product,this.config.sizeOption);
    if(this.ci<0||this.si<0||this.product.options.length!==2)return false;
    this.colors=[...new Set(this.product.variants.map(v=>optionsOf(v)[this.ci]))];
    this.sizes=[...new Set(this.product.variants.map(v=>optionsOf(v)[this.si]))];
    if(!this.product.variants.some(v=>v.available))return false;
    this.renderVariants();return true;
  }
  setupVideo(signal){
    this.querySelectorAll('.wc-video').forEach(section=>{
      const video=section.querySelector('video'),overlay=section.querySelector('.wc-play-overlay'),message=section.querySelector('.wc-video-message');
      if(!video)return;
      const sync=()=>{if(overlay)overlay.hidden=!video.paused;};
      video.addEventListener('play',sync,{signal});video.addEventListener('pause',sync,{signal});video.addEventListener('ended',sync,{signal});
      section.querySelectorAll('.wc-watch,.wc-play-overlay').forEach(button=>button.addEventListener('click',async()=>{
        message.hidden=true;button.disabled=true;
        try{await video.play();video.focus({preventScroll:true});}catch{message.textContent='La vidéo ne se charge pas. Réessayez dans un instant.';message.hidden=false;}finally{button.disabled=false;}
      },{signal}));
    });
  }
  renderVariants(){
    const container=this.querySelector('[data-variant-rows]');container.replaceChildren();
    if(!this.colors){
      for(let i=0;i<this.quantity;i++){
        const fieldset=document.createElement('fieldset');fieldset.className='wc-pair';
        const legend=document.createElement('legend');legend.textContent='Paire '+(i+1);fieldset.append(legend);
        const label=document.createElement('label');label.textContent='Pointure';const select=document.createElement('select');select.disabled=true;select.append(new Option('Indisponible',''));label.append(select);fieldset.append(label);container.append(fieldset);
      }
      return;
    }
    for(let i=0;i<this.quantity;i++){
      const preferred=this.colors.find(c=>c.toLowerCase()===(i===0?'noir':'marron'))||this.colors[0];
      const availableColor=this.selectionOnly?null:this.product.variants.find(v=>v.available&&optionsOf(v)[this.ci]===preferred)||this.product.variants.find(v=>v.available);
      this.selections[i]||={color:this.selectionOnly?preferred:availableColor?optionsOf(availableColor)[this.ci]:preferred,size:''};
      const selection=this.selections[i];
      if(selection.size&&(this.selectionOnly?!this.sizes.includes(selection.size):!findVariant(this.product,selection.color,selection.size,this.ci,this.si)))selection.size='';
      const fieldset=document.createElement('div');fieldset.className='pair wc-pair';
      const legend=document.createElement('b');legend.textContent='Paire '+(i+1);fieldset.append(legend);
      const pairFields=document.createElement('div');pairFields.className='pair-fields';fieldset.append(pairFields);
      for(const [kind,label,values] of [['color','Couleur',this.colors],['size','Pointure',this.sizes]]){
        const wrapper=document.createElement('label');wrapper.textContent=label;
        const select=document.createElement('select');select.name=kind+'_'+i;select.required=true;
        select.id=this.form.id+'-'+kind+'-'+i;
        if(kind==='size'){const empty=new Option('Choisir','',false,!selection.size);select.append(empty);}
        values.forEach(value=>{
          const available=this.selectionOnly|| (kind==='color'?this.product.variants.some(v=>v.available&&optionsOf(v)[this.ci]===value):Boolean(findVariant(this.product,selection.color,value,this.ci,this.si)));
          const option=new Option(value+(available?'':' — indisponible'),value,false,selection[kind]===value);option.disabled=!available;select.append(option);
        });
        select.addEventListener('change',()=>{selection[kind]=select.value;const id=select.id;this.renderVariants();this.querySelector('#'+CSS.escape(id))?.focus();this.updateTotal();if(i===0&&kind==='color')this.updateHero(selection.color);});
        wrapper.append(select);pairFields.append(wrapper);
      }
      container.append(fieldset);
    }
  }
  selectedVariants(){return this.selectionOnly?[]:this.selections.slice(0,this.quantity).map(s=>findVariant(this.product,s.color,s.size,this.ci,this.si));}
  updateTotal(){
    const amount=new Intl.NumberFormat('fr-MA').format(this.config.prices[this.quantity-1]/100)+' DH';
    this.querySelector('[data-total]').textContent=amount;
    const buttonTotal=this.querySelector('[data-button-total]');if(buttonTotal)buttonTotal.textContent=amount;
    if(!this.busy)this.buttonHTML=this.submitButton.innerHTML;
  }
  showError(message){this.error.textContent=message;this.error.hidden=false;}
  validate(){
    let first;
    this.form.querySelectorAll('input:not([type=radio]),select').forEach(input=>{
      const valid=input.name==='phone'?Boolean(normalizePhone(input.value)):input.tagName==='SELECT'?Boolean(input.value):input.value.trim().length>=2;
      input.setAttribute('aria-invalid',String(!valid));if(!valid&&!first)first=input;
    });
    if(first){first.focus();this.showError('Choisissez la pointure de chaque paire et renseignez votre nom, téléphone marocain, ville et adresse.');return false;}
    if(!this.catalogReady||this.selectedVariants().length!==this.quantity||this.selectedVariants().some(v=>!v?.available)){this.showError('Cette couleur ou pointure n’est plus disponible. Vérifiez votre sélection.');return false;}
    return true;
  }
  async get(path){
    const base=this.config.root.replace(/\/?$/,'/');
    const response=await fetch(base+path,{credentials:'same-origin',headers:{Accept:'application/json'},signal:AbortSignal.timeout(15000)});
    if(!response.ok)throw new Error('Impossible de vérifier la disponibilité. Réessayez dans un instant.');
    return response.json();
  }
  buildSheetPayload(receipt){
    const now=new Date();
    const amountCents=Number(this.config.prices[this.quantity-1])||0;
    const shoes=this.selections.slice(0,this.quantity).map((selection,index)=>({
      number:index+1,
      product:this.product?.title||'Chaussures WEARSE classiques',
      color:selection.color,
      size:selection.size,
    }));
    const params=new URLSearchParams(window.location.search);
    const receiptId=String(receipt?.id||Date.now()).replace(/[^a-zA-Z0-9_-]/g,'');
    const payload={
      landing:'offre-chaussures',
      landing_page:'offre-chaussures',
      sheet_name:'offre-chaussures',
      sheet:'offre-chaussures',
      worksheet:'offre-chaussures',
      orderNumber:'WEARSE-CHAUSSURES-'+receiptId,
      request_id:'WEARSE-CHAUSSURES-'+receiptId,
      shopify_order_id:String(receipt?.id||''),
      shopify_order_reference:String(receipt?.reference||''),
      submitted_at:now.toISOString(),
      dateLabel:now.toLocaleString('fr-MA'),
      fullName:this.form.elements.fullName.value.trim(),
      phone:normalizePhone(this.form.elements.phone.value),
      city:this.form.elements.city.value.trim(),
      address:this.form.elements.address.value.trim(),
      offer:this.quantity+' paire'+(this.quantity>1?'s':''),
      offer_quantity:this.quantity,
      item_count:this.quantity,
      price:new Intl.NumberFormat('fr-MA').format(amountCents/100)+' DH',
      total_price:amountCents,
      currency:'MAD',
      payment_method:'cash_on_delivery',
      shoes,
      shoes_json:JSON.stringify(shoes),
      source:window.location.href,
      userAgent:navigator.userAgent,
      status:'Nouveau',
      utm_source:params.get('utm_source')||'',
      utm_campaign:params.get('utm_campaign')||'',
      utm_content:params.get('utm_content')||'',
      utm_medium:params.get('utm_medium')||'',
      fbclid:params.get('fbclid')||'',
    };
    shoes.forEach(item=>{
      payload['color_'+item.number]=item.color;
      payload['size_'+item.number]=item.size;
    });
    return payload;
  }
  async postSheetPayload(payload){
    if(!this.config.endpoint)throw new Error('Google Sheets endpoint is missing.');
    try{localStorage.setItem(sheetPendingKey,JSON.stringify(payload));}catch{}
    await fetch(this.config.endpoint,{
      method:'POST',
      mode:'no-cors',
      keepalive:true,
      headers:{'Content-Type':'text/plain;charset=UTF-8'},
      body:JSON.stringify(payload),
    });
    try{localStorage.removeItem(sheetPendingKey);}catch{}
  }
  async retryPendingSheetSync(){
    let payload;
    try{payload=JSON.parse(localStorage.getItem(sheetPendingKey)||'null');}catch{return;}
    if(!payload||!this.config.endpoint)return;
    try{await this.postSheetPayload(payload);}catch(error){console.error('WEARSE sheet retry failed',error);}
  }
  async submit(event){
    event.preventDefault();if(this.busy||this.completed||!this.validate())return;
    this.error.hidden=true;
    if(this.config.preview){this.showError('Aperçu local : aucune commande n’est envoyée.');return;}
    if(!this.config.enabled){this.showError('La commande de ce modèle est momentanément indisponible.');return;}
    if(hasPendingOrder()){this.showError('Une commande attend déjà confirmation. Contactez-nous avant de la renvoyer.');return;}
    this.busy=true;this.form.setAttribute('aria-busy','true');this.submitButton.textContent='Vérification de votre offre…';
    const controls=[...this.querySelectorAll('input,select,button')].filter(el=>!el.disabled);controls.forEach(el=>el.disabled=true);
    try{
      // EasySell builds this offer in its own virtual cart; an existing Shopify
      // cart must not block a separate landing-page order or be emptied here.
      this.querySelector('.wc-cart-link').hidden=true;
      this.product=await this.get('products/'+encodeURIComponent(this.product.handle)+'.js');
      const variants=this.selectedVariants();
      if(variants.length!==this.quantity||variants.some(v=>!v?.available)){this.renderVariants();throw new Error('Une pointure n’est plus disponible. Modifiez vos choix.');}
      if(variants.some(v=>v.price!==39900))throw new Error('Le prix du produit a changé. Contactez-nous pour vérifier cette offre.');
      await submitEasySell(this);
      this.completed=true;this.submitButton.textContent='Commande enregistrée';
    }catch(error){this.showError(error.name==='TimeoutError'?'La vérification a pris trop de temps. Réessayez dans un instant.':error.message);this.error.focus();}
    finally{
      this.busy=false;this.form.removeAttribute('aria-busy');controls.forEach(el=>el.disabled=Boolean(this.completed));
      if(!this.completed){
        this.submitButton.disabled=hasPendingOrder();
        this.submitButton.innerHTML=this.submitButton.disabled?'Confirmation à vérifier':this.buttonHTML;
      }
    }
  }
}
if(!customElements.get('wearse-classic'))customElements.define('wearse-classic',WearseClassic);
